// Libraries
import { FC } from "react";
import { Title } from "@radix-ui/react-dialog";
import { AiOutlineClose } from "react-icons/ai";

import { Button } from "components/common/buttons/Button";

// Types
import { ModalTitleProps } from "./ModalTitle.types";

export const ModalTitle: FC<ModalTitleProps> = ({ children, onClose, className = "" }) => {
  return (
    <Title
      className={`flex flex-row items-center justify-between gap-3 font-normal text-foreground text-left text-inter text-[20px] leading-none${className ? ` ${className}` : ""}`}
      data-testid="modal-title"
    >
      <span className="flex min-w-0 items-center gap-2">{children}</span>
      {onClose ? (
        <Button
          name="close"
          color="gray"
          size="icon"
          className="h-7 w-7 shrink-0"
          type="button"
          onClick={onClose}
          aria-label="Close modal"
        >
          <AiOutlineClose />
        </Button>
      ) : null}
    </Title>
  );
};

export default ModalTitle;
